module.exports = __webpack_public_path__ + "img/组 105.db3b50a0.png";